module.exports = __webpack_public_path__ + "bbb0f4ffa1fcdcfc564e1ebf38780465.pdf";